// src/components/ServicesPage.js
import React from "react";

export default function ServicesPage() {
  return (
    <main className="container py-5">
      <header className="mb-4">
        <h1 className="fw-bold">Services</h1>
        <p className="text-muted">What we offer — pick a package or request a custom quote.</p>
      </header>

      <section className="row g-4">
        <article className="col-md-6 col-lg-4">
          <div className="card h-100 shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Landing Pages</h5>
              <p className="card-text text-muted">High-converting marketing pages for campaigns & products — fast turnaround.</p>
              <p className="mb-0"><strong>From €300</strong></p>
            </div>
          </div>
        </article>

        <article className="col-md-6 col-lg-4">
          <div className="card h-100 shadow-sm">
            <div className="card-body">
              <h5 className="card-title">SPA / Dashboards</h5>
              <p className="card-text text-muted">React single-page apps, authenticated dashboards and admin panels.</p>
              <p className="mb-0"><strong>From €900</strong></p>
            </div>
          </div>
        </article>

        <article className="col-md-6 col-lg-4">
          <div className="card h-100 shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Testing & QA</h5>
              <p className="card-text text-muted">Unit + E2E tests (Jest + Cypress/Playwright), CI integration and test automation.</p>
              <p className="mb-0"><strong>Per project</strong></p>
            </div>
          </div>
        </article>
      </section>

      <section className="mt-5">
        <h3 className="fw-semibold">Custom Work & Integrations</h3>
        <p className="text-muted">APIs, payment gateways, e-commerce platforms, and devops automation — we scope and quote per project.</p>

        <a href="/contact" className="btn btn-primary rounded-pill mt-3">Request a Quote</a>
      </section>
    </main>
  );
}
